import { Amplify, API, Auth } from "aws-amplify";
import awsExports from "src/aws-exports";
import { API_NAME } from "src/config";
import { AwsGateRequest, AwsGateResponse, ServiceType } from "src/types";
import { useMockend } from "../mockend/mockend.hook";

Amplify.configure(awsExports);
Auth.configure(awsExports);

const API_VERSION_BASED_ON_SERVICE = {
  [ServiceType.CAI]: "v2",
  [ServiceType.COMMUNICATION]: "v2",
  [ServiceType.DOCUMENT]: "v1",
};

export const useAwsGateRequest = <T, D>(
  gateId: string,
  service: ServiceType
) => {
  const { isMocked, getMock } = useMockend();

  const doRequest = async ({
    method = "get",
    path,
    ...request
  }: AwsGateRequest<T>): Promise<AwsGateResponse<D>> => {
    const version = API_VERSION_BASED_ON_SERVICE[service];
    if (isMocked(gateId)) {
      const { data } = await getMock(gateId);
      console.log(
        "[FROM MOCK]: ",
        "\nGATE: ",
        gateId,
        "\nSERVICE: ",
        service,
        "\nMOCKED ENDPOINT: ",
        `${API_NAME}/${service}/${version}${path}`,
        "\nREQUEST: ",
        request,
        "\nRESPONSE: ",
        data
      );
      if ((data as any)?.errorCode) {
        throw data as AwsGateResponse<D>;
      }
      return data as AwsGateResponse<D>;
    }

    const response = await API[method](
      API_NAME,
      `/${service}/${version}${path}`,
      request
    );
    if (response?.errorCode) {
      throw response;
    }
    return response;
  };

  return { doRequest };
};
